"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.IconButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _IconButtonSt = require("./IconButton.st.css");
var _CoreButtonNext = require("../internal/WixUiCoreComponents/components/CoreButtonNext");
var _deprecationLog = require("../../common/deprecationLog");
var _types = require("./types");
var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-ui-tpa/dist/cjs/components/IconButton/IconButton.tsx";
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/** An implementation of an IconButton for TPAs,
 * The TPA implementation provides few extendable theme properties with the ability to override the base properties as well.
 * By default the IconButton will pull the theme from the site (site color scheme) */
class IconButton extends React.Component {
  componentDidMount() {
    if (this.props.skin) {
      (0, _deprecationLog.deprecationLog)('IconButton', 'The prop "skin" is deprecated and will be removed in a future version, please use Toggle icons instead.');
    }
  }
  render() {
    const {
      icon,
      disabled,
      skin,
      className,
      innerRef,
      theme,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(_CoreButtonNext.CoreButtonNext, (0, _extends2.default)({
      className: (0, _IconButtonSt.st)(_IconButtonSt.classes.root, {
        disabled,
        skin,
        theme
      }, _IconButtonSt.classes[`skin-${skin}`], className)
    }, rest, {
      ref: innerRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: _IconButtonSt.classes.icon,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45,
        columnNumber: 9
      }
    }, icon));
  }
}
exports.IconButton = IconButton;
(0, _defineProperty2.default)(IconButton, "displayName", 'IconButton');
(0, _defineProperty2.default)(IconButton, "defaultProps", {
  skin: _types.IconButtonSkins.Line,
  theme: _types.IconButtonThemes.None
});
//# sourceMappingURL=IconButton.js.map